import { DefinitionSummaryModel } from "../../helpers/ApiResources";

// Typescript User-Defined Type Guard
export function isInstanceOfDefinitionSummaryModel(
  object: any
): object is DefinitionSummaryModel {
  return "id" in object && "name" in object;
}
